// Modules
import cn from 'classnames';

// Types
import type { TCardHeaderProps } from './Card.type';

// Styles
import styles from './styles.module.scss'

const CardHeader = (props: TCardHeaderProps) => {
	const {
		className,
		description,
		descriptionClassName,
		iconLeft,
		iconLeftClassName,
		iconRight,
		iconRightClassName,
		title,
		titleClassName,
		...restProps
	} = props

	const cardHeaderCN = cn(styles.legion_card_header, className, {
		[styles.full_content]: !!title && !!description,
	})
	const iconLeftCN = cn(styles.icon_left, iconLeftClassName)
	const iconRightCN = cn(styles.icon_right, iconRightClassName)
	const titleCN = cn(styles.header_title, titleClassName)
	const descriptionCN = cn(styles.header_description, descriptionClassName)

	return (
		<div className={cardHeaderCN} {...restProps}>
			{iconLeft && <div className={iconLeftCN}>{iconLeft}</div>}
			<div className={styles.header_content}>
				{title && <h3 className={titleCN}>{title}</h3>}
				{description && <p className={descriptionCN}>{description}</p>}
			</div>
			{iconRight && <div className={iconRightCN}>{iconRight}</div>}
		</div>
	)
}

export default CardHeader;
